// extracted by mini-css-extract-plugin
export default {"image":"WXa_jlc4"};